document.addEventListener('DOMContentLoaded', () => {

  const toggleBtn = document.getElementById('express-toggle-btn');
  const flowBox = document.getElementById('express-flow');

  const cityInput = document.getElementById('shipping-city-input');
  const citySuggestions = document.getElementById('city-suggestions');

  const methodsBox = document.getElementById('express-methods');
  const errorBox = document.getElementById('express-error');

  const radios = document.querySelectorAll('input[name="express_method"]');
  
    const cities = Array.isArray(window.SHIPPING_CITIES)
    ? window.SHIPPING_CITIES
    : [];

    if (!cities.length) {
    console.warn('SHIPPING_CITIES not loaded');
    return;
    }
    
  let flowOpen = false;
  let selectedCity = null;

  /* TOGGLE */
  toggleBtn.addEventListener('click', () => {
    flowOpen = !flowOpen;

    flowBox.style.display = flowOpen ? 'block' : 'none';

    if (!flowOpen) {
      resetExpressUI();
      window.removeExpressShipping?.();
    }
  });

  /* CITY AUTOCOMPLETE */
  cityInput.addEventListener('input', () => {
    const q = cityInput.value.trim().toLowerCase();
    citySuggestions.innerHTML = '';

    if (q.length < 2) return;

    cities
      .filter(c => c.city_name.toLowerCase().includes(q))
      .slice(0, 8)
      .forEach(city => {
        const li = document.createElement('li');
        li.textContent = city.city_name;

        li.onclick = () => {
          selectedCity = city;
          cityInput.value = city.city_name;
          citySuggestions.innerHTML = '';

          if (city.express_enabled === true) {
            methodsBox.style.display = 'block';
            errorBox.style.display = 'none';
          } else {
            methodsBox.style.display = 'none';
            errorBox.style.display = 'block';
            radios.forEach(r => r.checked = false);
            window.removeExpressShipping?.();
          }
        };

        citySuggestions.appendChild(li);
      });
  });

  /* METHOD SELECT */
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (!selectedCity || !selectedCity.express_enabled) return;
      window.addExpressShipping?.(radio.value);
    });
  });

  function resetExpressUI() {
    cityInput.value = '';
    citySuggestions.innerHTML = '';
    methodsBox.style.display = 'none';
    errorBox.style.display = 'none';
    radios.forEach(r => r.checked = false);
    selectedCity = null;
  }

});